import * as API from '../'
export default {
     // 设备类型列表
    getList: params => {
        return API.POST('/api/third/device/type/getAllList', params)
    },
    insert:params=>{
        return API.postJsonRequest("/api/third/device/type/add",params);
    },
    detail:params=>{
        return API.GET("/api/third/device/type/detail/"+ params);
    },
    update:params=>{
        return API.postJsonRequest("/api/third/device/type/update",params);
    },
    delete:params=>{
        return API.postJsonRequest("/api/third/device/type/delete/"+params);
    }

}


// WEBPACK FOOTER //
// ./src/api/third/dict.js